import React from 'react';
import { Typography, Layout } from 'antd';
import MainHeader, { MENU_APPROVE_LOGWOOD } from '../components/common/MainHeader';
import LogWoodPOList from '../components/log-wood-po/LogWoodPOList';
import LogWoodPOMobileList from "../components/log-wood-po/mobile/LogWoodPOMobileList";
import { Media } from "../AppMedia";
import { useTranslation } from 'react-i18next';

function LogWoodPOListView() {
  const { t } = useTranslation();
  const { Title } = Typography;

  return (
    <div>
      <MainHeader activeItem={MENU_APPROVE_LOGWOOD} />
      <Layout>
        <Layout.Content style={{ margin: '24px', marginTop: '7em' }}>
          <Title level={2}>{t('menus.wood_menus.log_wood_po')}</Title>
          
              <Media lessThan="md">
                <LogWoodPOMobileList />
              </Media>
            
              <Media greaterThanOrEqual="md">
                <LogWoodPOList />
              </Media>
            
        </Layout.Content>
      </Layout>
    </div>
  );

}

export default LogWoodPOListView;